import { useMemo } from 'react'
import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useOrpc } from '@/hooks/useClient'

/** The middleware's refusal, word for word (icd10cm-billable.ts, PD-2014). */
export function nonBillableMessage(codes: string[]): string {
  return `${codes.join(', ')} ${codes.length === 1 ? 'is' : 'are'} not valid for claim submission. Select a more specific diagnosis supported by the progress note.`
}

/**
 * PD-2014 — whether each ICD-10-CM code may go on a claim on the visit date, with the
 * billable codes under a category code. Shared by the billing editor and the progress
 * note's Problem List (PD-2016).
 */
export function useIcd10Billability(codes: string[], dateOfService: string, enabled: boolean) {
  const orpc = useOrpc()
  const query = useQuery(
    orpc.billingIcd10Billability.queryOptions({
      input: { codes, dateOfService },
      enabled: enabled && codes.length > 0,
      staleTime: 5 * 60_000,
      placeholderData: keepPreviousData,
    }),
  )
  const byCode = useMemo(
    () => new Map((query.data?.codes ?? []).map((result) => [result.code, result])),
    [query.data],
  )
  return { query, byCode }
}
